module.exports = __webpack_public_path__ + "static/media/pdf_icon.7d7b22ee.svg";